import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

const selectAiAgentsState = createSelector(getSystem, ({ aiAgents }) => aiAgents);

export const selectAiAgents = createSelector(selectAiAgentsState, ({ agents }) => agents);

export const selectAiAgentTemplates = createSelector(
  selectAiAgentsState,
  ({ templates }) => templates,
);

export const selectAiAgentsWithEnabledTemplates = createSelector(
  [selectAiAgents, selectAiAgentTemplates],
  (agents, templates) => [
    ...agents.map(agent => ({ ...agent, isTemplate: false, isEnabled: true })),
    ...templates
      .filter(template => template.isEnabled)
      .map(template => ({ ...template, isTemplate: true })),
  ],
);

export const selectAiAgentById = id =>
  createSelector(selectAiAgentsWithEnabledTemplates, items => items.find(a => a.id === id));

export const selectAiAgentsOptions = createSelector(selectAiAgents, agents =>
  agents.map(({ id, displayName }) => ({ name: displayName, value: id })),
);
